import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

/**
 * Small but visible non-emergency notice. Shown across urgent-care pages.
 */
export const EmergencyNotice = ({ className = "" }) => {
  const { t } = useTranslation();
  const text = t("notices.emergency");
  const [before, after] = text.split("115");
  return (
    <div
      data-testid="emergency-notice"
      role="note"
      className={`flex items-start gap-3 rounded-xl border border-[hsl(0_74%_88%)] bg-[hsl(0_80%_98%)] px-4 py-3 ${className}`}
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-[hsl(0_74%_48%)]" />
      <p className="text-sm leading-relaxed text-[hsl(0_45%_32%)]">
        {before}
        <span className="font-bold text-[hsl(0_74%_44%)]">115</span>
        {after}
      </p>
    </div>
  );
};

export default EmergencyNotice;
